import { usePaginatedApi } from "../../../swr/useApi";

import { salesService } from "../../api_client";
import type {
    SaleDto,
    SalesQueryDto,
} from "../../../api";

export function useSales(query?: SalesQueryDto) {
    return usePaginatedApi<SaleDto, SalesQueryDto>({
        key: "sales",
        serviceMethod: async (queryParams) => await salesService.getSales(queryParams),
        query: query,
        options: { refreshInterval: 30_000 },
    });
}

